import ConnectedRouteHandler from './ConnectedRouteHandler';
import RouteHandler from './RouteHandler';

export { RouteHandler };
export default ConnectedRouteHandler;
